export function mergePricingConfigs(
  pricingConfig = {},
  regularPricingConfig = {}
) {
  if (!pricingConfig.products || !regularPricingConfig.products) return []

  const configProducts = Object.assign(
    {},
    ...pricingConfig.products.map((product) => {
      return {
        [product.duration]: {
          ...product,
          coupon: pricingConfig.coupon,
          currency: pricingConfig.currency,
          trialDuration: pricingConfig.trialDuration,
          discount: pricingConfig.discount,
          discountOnlyFirstPurchase: pricingConfig.discountOnlyFirstPurchase,
        },
      }
    })
  )

  const regularProducts =
    pricingConfig.discountType === '%'
      ? Object.assign(
          {},
          ...regularPricingConfig.products.map((product) => {
            return {
              [product.duration]: {
                ...product,
                currency: regularPricingConfig.currency,
                trialDuration: regularPricingConfig.trialDuration,
                discount: null,
                isRegularPrice: true,
              },
            }
          })
        )
      : {}

  return Object.values({
    ...regularProducts,
    ...configProducts,
  })
}
